import { motion } from "framer-motion";
import React, { useReducer } from "react";
import { CreditDialog } from "../credit-dialog";
import CreditBarContent from "./credit-bar-content";
import CreditBarTrigger from "./credit-bar-trigger";

function CreditBar() {
  const [contentOpen, toggleContent] = useReducer((state) => !state, false);
  const [buyOpen, toggleBuy] = useReducer((state) => !state, false);

  return (
    <div className="relative">
      <CreditBarTrigger handleOpen={toggleContent} />

      {contentOpen && (
        <CreditBarContent
          onBuy={() => {
            toggleBuy();
            toggleContent();
          }}
          onClose={toggleContent}
        />
      )}

      {contentOpen && (
        <motion.div
          className="fixed inset-0 z-10 bg-neutral-dark-pure opacity-30"
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 0.3,
          }}
        />
      )}

      {buyOpen && <CreditDialog onClose={toggleBuy} />}
    </div>
  );
}

export default React.memo(CreditBar);
